"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceType = void 0;
var ResourceType;
(function (ResourceType) {
    ResourceType["CHAT_MESSAGE"] = "chatMessage";
    ResourceType["EXTERNAL_CHAT_MESSAGE"] = "externalChatMessage";
    ResourceType["COMPANY"] = "company";
    ResourceType["FILE"] = "file";
    ResourceType["PROJECT"] = "project";
    ResourceType["TASK"] = "task";
    ResourceType["TASK_TIME"] = "taskTime";
    ResourceType["TRACKED_TIME"] = "trackedTime";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
//# sourceMappingURL=ResourceType.js.map